module.exports = __webpack_public_path__ + "img/foldgaz.abc2ad47.jpg";